// test1270
(1270 && 0);
